import { GoHighLevelLocation } from '@mm/state/model/GoHighLevelModel';
import { KlaviyoListsResponse } from '@mm/state/model/KlaviyoModel';
import { SendlaneListsResponse } from '@mm/state/model/SendlaneModel';
import { Select } from 'antd';
import React from 'react';
import styles from './WidgetConnectionLists.module.css';

type Props = {
  defaultValue?: string;
  lists:
    | GoHighLevelLocation[]
    | KlaviyoListsResponse[]
    | SendlaneListsResponse[];
  onChange: (listId: string) => void;
};

export const WidgetConnectionLists = ({
  defaultValue,
  lists,
  onChange,
}: Props) => (
  <div className={styles.container}>
    <div className={styles.title}>Choose List to Sync to</div>
    <div className={styles.row}>
      <Select
        className={styles.listsSelect}
        defaultValue={defaultValue}
        placeholder="Choose"
        onChange={listId => onChange(listId)}
        options={lists.map(loc => ({ value: loc.id, label: loc.name }))}
        popupClassName={styles.popup}
        getPopupContainer={trigger => trigger.parentNode}
      />
    </div>
  </div>
);
